import React, { useState } from "react";
import styles from "../../Application.module.scss";
import HeadingWithLine from "../../../../components/HeadingWithLine/HeadingWithLine";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import useCommonStore from "../../../../stores/common";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import CaretRight24 from "../../../../assets/svg/icons/common/CaretRight24";

function Underwriting({ appData }) {
  const expandAppDetails = useCommonStore((state) => state.expandDetails);
  const [expanded, setExpanded] = useState(false);
  const isMobile = useMediaQuery(768);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const renderSection = (title, items) => {
    return (
      <div className={styles.info_section}>
        {title && (
          <>
            <div className={styles.section_title}>
              <h5>{title}</h5>
            </div>
            <div className={styles.desktop_heading}>
              <HeadingWithLine text={title} />
            </div>
          </>
        )}
        <div className={styles.info_grid}>
          {items.map((item, index) => (
            <div key={index} className={styles.info_item}>
              <span className={styles.label}>{item.label}</span>
              <span className={styles.value}>{item.value}</span>
            </div>
          ))}
        </div>
        <ul className={styles.desktop_list}>
          {items.map((item, index) => (
            <li key={index}>
              <div>
                <p>{item.label}</p>
                <p>{item.value}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const underwritingItems = [
    { label: "Underwriting Note", value: appData?.uw_notes || "-" },
  ];

  return (
    <div
      className={`${isMobile ? styles.mobile_business_info : styles.underwriting} ${expandAppDetails ? styles.expanded : ""}`}
    >
      <div className={isMobile ? styles.business_info_header : styles.head} onClick={toggleExpanded}>
        {isMobile ? (
          <>
            <CaretRight24 className={`${styles.caret_icon} ${expanded ? styles.expanded : ""}`} />
            <h4>Underwriting</h4>
          </>
        ) : (
          <>
            <ButtonIcon>
              <CaretRight24 className={expanded ? styles.expanded : ""} />
            </ButtonIcon>
            <h5>Underwriting</h5>
          </>
        )}
      </div>

      <div
        className={`${isMobile ? styles.mobile_content : styles.body} ${expanded ? (isMobile ? styles.expanded : styles.body_expanded) : ""} ${expandAppDetails ? styles.app_details_expanded : ""}`}
      >
        {expanded && renderSection(null, underwritingItems)}
      </div>
    </div>
  );
}

export default Underwriting;
